import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, AfterContentInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
// service
import { FlightDetailsService } from '../../../shared/services/flight-details.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { ErrorHandler } from '../../../shared/services/error-handler.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
// models
import { AppState } from '../../../booking/models/app-state.interface';
import { FlightFinderInitState } from '../../../shared/models/flight-finder.interface';
import { ModalData } from '../../../shared/models/modal.interface';

declare var ga: any;

@Component({
  selector: 'app-flyback-flight-results',
  templateUrl: './flyback-flight-results.component.html',
  styleUrls: ['./flyback-flight-results.component.scss']
})
export class FlybackFlightResultsComponent implements OnInit {
  @Input() bookingReference;
  @Input() flightDirection;
  @Input() flightData;
  @Input() airline;
  @Input() firstLoad;
  @Input() flightResults;
  @Input() flightResultsLoading;
  @Input() flightSelectionInprogress;
  @Input() flightConnectionCount;

  @Input() copyLoaded;
  @Input() appCopy;
  @Input() appAirportCopy;
  @Input() selectedLanguage;
  @Input() languageCode;

  @Input() pagingArr;
  @Input() pageSetSize;
  @Input() selectedPage;
  @Input() activeSetIndex;

  @Input() showFlyBackSection;

  @Output() handlePageClick: EventEmitter<any> = new EventEmitter;
  @Output() handlePageNumberClick: EventEmitter<any> = new EventEmitter;

  @Output() selectFlight: EventEmitter<any> = new EventEmitter;
  @Output() searchNonDirect: EventEmitter<any> = new EventEmitter;
  @Output() flightNumberFilter: EventEmitter<any> = new EventEmitter;
  @Output() cancelFlightRequest: EventEmitter<any> = new EventEmitter;

  private _flightStoreData: Subscription;

  public flightSelectionDisabled = false;
  public flightLeg = {
    direct: true,
    oneStop: false,
    twoStop: false
  };
  public direction = null;
  public flightNumber = { value: null };
  public flightLoading = false;
  public filteredCombinedFlights = null;
  public selectedFlight = null;
  public legsFilter = '0';
  public activeRadioIndex = 0;
  public selectedFlightId = null;
  public quoteFlightNumber = null;
  public showFlightDetails = false;

  public departureAirport;
  public arrivalAirport;
  public flightReturnDate = moment().toString();
  public showRecords: number = 3;

  constructor(
    private _appStore: Store<AppState>,
    private _flightDetailsService: FlightDetailsService,
    private _errorService: ErrorHandler,
    private _dataStorageService: DataStorageService,
    private _router: Router,
  ) { }

  ngAfterContentInit(): void {
    if (this.quoteFlightNumber) {
      for (let item = 0; item < this.flightResults.length; item++) {
        if (this.quoteFlightNumber === this.flightResults[item].flightStatusDetails[0].flightNumber) {
          this.toggleSelectedItem(null, this.flightResults[item].flightInfo)
        }
      }
    }
  }

  ngOnInit(): void {
    this.departureAirport =
      this.flightData.flightStatusDetails[
        this.flightData.flightStatusDetails.length - 1
      ].arrivalAirport;

    this.arrivalAirport = this.flightData.flightStatusDetails[0].departureAirport;
    this.flightReturnDate = this.getState(this._appStore).flybackReducer.flybackFlightDate;

    this._flightStoreData = this._appStore.select('flightFinderReducer')
      .subscribe((res: FlightFinderInitState) => {

        if (res.requestCount === 0) {
          this.quoteFlightNumber = res.quoteFlightRequest.flightNumber;
          this.flightLeg = res.filterLegs;
          this.activeRadioIndex = Object.keys(this.flightLeg).map(key => this.flightLeg[key]).findIndex(item => item === true);
          this.legsFilter = this.activeRadioIndex.toString();
          this.flightSelectionDisabled = res.userHasSelected;

          // if (this.flightSelectionDisabled) {
          //   this.flightResultsLoading = true;
          // } else {
          //   this.flightResultsLoading = false;
          //   this.flightSelectionInprogress = false;
          // }

          if (this.direction === null) {
            this.direction = this._flightDetailsService.checkDirection(this.flightData.originAirportCode);
          }

        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    // this.flightResultsLoading = false;
    // this.showRecords = 3;
    if (typeof changes.flightResults !== 'undefined') {

      if(this.firstLoad){
        this.showRecords = changes.flightResults.currentValue.length > 3 ? 3 : changes.flightResults.currentValue.length;
      }

      if (changes.flightResults.currentValue.length === 1) {
        this.toggleSelectedItem(null, changes.flightResults.currentValue[0].flightInfo.id);
      }
    }
  }

  searchByFlightNumber(event) {
    if (event.target.value === null || event.target.value === '') { return; }
    this.selectFlight.emit({ flight: { flightNumberSearch: true, flightNumber: event.target.value } });
  }

  handleResultPageClick(page) {
    this.handlePageClick.emit(page)
  }


  handleResulPageNumberClick(item) {
    this.handlePageNumberClick.emit(item)
  }

  toggleSelectedItem(event, flightInfo) {
    const _id = flightInfo.id
    if (this.selectedFlightId !== _id) {
      this.selectedFlightId = _id;
      this.showFlightDetails = true;
    } else {
      this.selectedFlightId = null;
      this.showFlightDetails = false;
    }
    ga('send', 'event', 'Vanilla', 'Result - Flight', flightInfo.requestFlightNumber);
  }

  handleCancelFlight() {
    this.selectedFlightId = null;
    this.showFlightDetails = false;
  }

  handleConfirmFlight(data) {
    this.showFlightDetails = false;
    this.selectFlight.emit(data);
  }

  filterLegChanged(event, modelItem) {
    this.flightLeg = {
      direct: false,
      oneStop: false,
      twoStop: false
    };
    this.flightLeg[modelItem] = true;

    // this.flightResultsLoading = true;
    this.activeRadioIndex = parseInt(event, 10);
    this.showRecords = 3;
    this.selectedFlightId = null;
    if (modelItem === 'direct') {
      this._appStore.dispatch({ type: 'UPDATE_API_SEARCH', payload: false });
    }
    this.searchNonDirect.emit(this.flightLeg);
    ga('send', 'event', 'Vanilla', 'Result - Legs', event);
  }

  // change
  toggleSearchModal() {
    const modalData: ModalData = {
      type: 'default',
      modalType: 'flightSearch',
      title: this.appCopy.panelHeader['EditFlightTitle' + this.selectedLanguage],
      content: '',
      buttonText: '',
      cancelButtonText: this.appCopy.panelHeader['linkCancel' + this.selectedLanguage],
      showLoader: true,
    };
    this._errorService.handleModal(modalData);
  }

  showLinkedFlights(e, flightData) {
    e.stopPropagation();

    const modalData: ModalData = {
      type: 'default',
      modalType: 'associatedFlight',
      title: this.appCopy.panelHeader['associatedFlightTitle' + this.selectedLanguage],
      cancelButtonText: this.appCopy.panelHeader['flightModalCloseBtn' + this.selectedLanguage],
      copyData: {
        airline: this.appCopy.panelHeader['airline' + this.selectedLanguage],
        flightNumber: this.appCopy.panelHeader['flightNumber' + this.selectedLanguage]
      },
      image: '',
      buttonText: '',
      showLoader: false,
      flightData: flightData,
    };
    this._errorService.handleModal(modalData);
  }





  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  abortFlyback() {
    this._appStore.dispatch({ type: 'UPDATE_FLYBACK_BOOKING_STATUS', payload: false });
    this._dataStorageService.saveData();

    this._router.navigate(["complete"], {
      queryParams: { ref: this.bookingReference },
    });
  }

  showMore() {
    const maxLength = this.flightResults.length; // 20 pageSize
    if (this.showRecords < maxLength && this.showRecords < 20) {
      this.showRecords = this.showRecords + 3;
    }

    if (this.showRecords > maxLength) {
      this.showRecords = maxLength;
    }
  }

  returnToPreviouseStep() {
    this._appStore.dispatch({ type: 'DECREMENT_CURRENT_STEP' });

    this._dataStorageService.saveData();

    this._router.navigate(['fly-back-details'], { queryParams: { ref: this.bookingReference } });

  }

  ngOnDestroy() {
    if (this._flightStoreData) { this._flightStoreData.unsubscribe(); }
    this.flightResults = [];
  }
}
